(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('company-type', {
            parent: 'entity',
            url: '/company-type?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.companyType.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company-type/company-types.html',
                    controller: 'CompanyTypeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('companyType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('company-type-detail', {
            parent: 'entity',
            url: '/company-type/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.companyType.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/company-type/company-type-detail.html',
                    controller: 'CompanyTypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('companyType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CompanyType', function($stateParams, CompanyType) {
                    return CompanyType.get({id : $stateParams.id});
                }]
            }
        })
        .state('company-type.new', {
            parent: 'company-type',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-type/company-type-dialog.html',
                    controller: 'CompanyTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('company-type', null, { reload: true });
                }, function() {
                    $state.go('company-type');
                });
            }]
        })
        .state('company-type.edit', {
            parent: 'company-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-type/company-type-dialog.html',
                    controller: 'CompanyTypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CompanyType', function(CompanyType) {
                            return CompanyType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('company-type.delete', {
            parent: 'company-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/company-type/company-type-delete-dialog.html',
                    controller: 'CompanyTypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CompanyType', function(CompanyType) {
                            return CompanyType.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('company-type', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
